import React from "react";

import { HexMenuItem } from "../../../hex-components/HexMenuItem.js";
import {
  ChartCellIcon,
  PivotCellIcon,
  TableCellIcon,
} from "../../icons/CustomIcons.js";

export const getDataBrowserMenuText = (cellType: string): string => {
  return `${cellType} cell`;
};

interface DataBrowserMenuItemsProps {
  createDisplayTableCell: () => void;
  createChartCell: () => void;
  createPivotCell: () => void;
  prefix?: string;
}

export const DataBrowserMenuItems: React.ComponentType<DataBrowserMenuItemsProps> =
  React.memo(function DataBrowserMenuItems({
    createChartCell,
    createDisplayTableCell,
    createPivotCell,
  }) {
    return (
      <>
        <HexMenuItem
          icon={<ChartCellIcon />}
          text={getDataBrowserMenuText("Chart")}
          onClick={createChartCell}
        />
        <HexMenuItem
          icon={<TableCellIcon />}
          text={getDataBrowserMenuText("Table")}
          onClick={createDisplayTableCell}
        />

        <HexMenuItem
          icon={<PivotCellIcon />}
          text={getDataBrowserMenuText("Pivot")}
          onClick={createPivotCell}
        />
      </>
    );
  });
